import {
  LoadingOutlined,
  ReloadOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { Button, Col, Form, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import "./index.css";

import NotificationApi from "../../../apis/NotificationApi";
import {
  disableViewTutorial,
  getParamFromUrl,
  getTutorialCode,
  isNullOrEmpty,
  showNotification,
} from "../../../common";
import FiledNameFromLockCer, {
  getFiledByType,
  getKeyByFiled,
} from "../../../common/FiledNameFromLockCer";
import SupportStatus from "../../../common/SupportStatus";
import ModalPromotion from "../../ModalPromotion";
import ContactInfo from "./ContactInfo";
import Header from "./Header";
import ProfileMissing from "./ProfileMissing";
import Titles from "../../../common/Titles";
import { Helmet } from "react-helmet";
import Footer from "../../footer";

const NotificationDoc = () => {
  const [loading, setLoading] = useState(false);
  const [isOpenModalProm, setIsOpenModalProm] = useState(false);
  const [linkPromotion, setLinkPromotion] = useState("");
  const [isFinish, setIsFinish] = useState(false);
  const [fileAdditionals, setFileAdditionals] = useState([]);
  const [specifiedDate, setSpecifiedDate] = useState([]);
  // const visbleFilesInit = {
  //   [FiledNameFromLockCer.TC_GTPL.filed]: false,
  //   [FiledNameFromLockCer.TC_CMND_NDD.filed]: false,
  //   [FiledNameFromLockCer.TC_DK0101.filed]: false,
  //   [FiledNameFromLockCer.CN_XACNHANTOCHUC.filed]: false,
  //   [FiledNameFromLockCer.CN_CMND.filed]: false,
  //   [FiledNameFromLockCer.CN_DK0102.filed]: false,
  //   [FiledNameFromLockCer.LINK_DK02.filed]: false,
  //   type: null,
  //   linkDk02: null,
  //   certificateSerial: "",
  // };
  // const [visbleFiles, setVisbleFiles] = useState([]);

  const [notificationResponse, setNotificationResponse] = useState([]);

  const [form] = Form.useForm();

  useEffect(() => {
    getTutorialCode();
    fetchDataDetail();
    const popupParam = getParamFromUrl("openPopup");
    if (!isNullOrEmpty(popupParam)) {
      setIsOpenModalProm(true);
      setLinkPromotion(popupParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    let maps = [];
    fileAdditionals.forEach((element) => {
      let fileRequest = [];
      for (const key in FiledNameFromLockCer) {
        if (FiledNameFromLockCer.hasOwnProperty(key)) {
          const enumItem = FiledNameFromLockCer[key];
          if (!isNullOrEmpty(element.files[enumItem.filed]?.data)) {
            getFile(fileRequest, enumItem.filed, element.files);
          }
        }
      }
      const fileSerial = {
        certificateSerial: element.certificateSerial,
        linkDk02: element.linkDk02,
        files: fileRequest,
      };
      maps.push(fileSerial);
    });

    let request = {
      ...values,
      maps: maps,
    };

    isNullOrEmpty(notificationResponse.id)
      ? handleRequest(NotificationApi.postProfileMissing, 201, request)
      : handleRequest(
          NotificationApi.putProfileMissing,
          200,
          notificationResponse.id,
          request
        );
  };

  const handleRequest = async (apiFunction, status, ...args) => {
    try {
      const res = await apiFunction(...args);
      if (res && res.status === status && res.data.data) {
        setIsFinish(true);
        setNotificationResponse(res.data.data);
        if (res.data.data.details) {
          handleLockTokenDetails(res.data.data.details, fileAdditionals);
        }
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const getFile = (fileRequest, filed, files) => {
    fileRequest.push({
      id: files[filed].id,
      fileName: files[filed].fileName,
      type: getKeyByFiled(files[filed].type),
      data: files[filed].data,
    });
  };

  const fetchDataDetail = async () => {
    setLoading(true);
    try {
      const res = await NotificationApi.detail();
      console.log("res: ", res);
      if (res && res.status === 200 && res.data.data) {
        handleDataResponse(res.data.data);
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const handleDataResponse = (data) => {
    let fileAdditionalNews = [];

    if (data.tokenProgramDetail) {
      // Chỉ dành cho các trường hợp thiếu hồ sơ
      const visbleFilesArray = [];
      data.tokenProgramDetail.forEach((value) => {
        // const cloneVisbleFiles = {
        //   ...visbleFilesInit,
        //   [FiledNameFromLockCer.TC_GTPL.filed]:
        //     value.tcGtpl && value.tcGtpl === 1,
        //   [FiledNameFromLockCer.TC_CMND_NDD.filed]:
        //     value.tcCmndNdd && value.tcCmndNdd === 1,
        //   [FiledNameFromLockCer.TC_DK0101.filed]:
        //     value.tcDk0101 && value.tcDk0101 === 1,
        //   [FiledNameFromLockCer.CN_XACNHANTOCHUC.filed]:
        //     value.cnXacnhantochuc && value.cnXacnhantochuc === 1,
        //   [FiledNameFromLockCer.CN_CMND.filed]:
        //     value.cnCmnd && value.cnCmnd === 1,
        //   [FiledNameFromLockCer.CN_DK0102.filed]:
        //     value.cnDk0102 && value.cnDk0102 === 1,
        //   [FiledNameFromLockCer.LINK_DK02.filed]: !isNullOrEmpty(
        //     value.linkDk02F
        //   ),
        //   type: value.type,
        //   linkDk02: value.linkDk02,
        //   certificateSerial: value.certificateSerial,
        // };
        // visbleFilesArray.push(cloneVisbleFiles);
        const files = {
          [FiledNameFromLockCer.TC_GTPL.filed]: {
            fileName: "",
            type: "",
            data: "",
            view: value.tcGtpl && value.tcGtpl === 1,
          },
          [FiledNameFromLockCer.TC_CMND_NDD.filed]: {
            fileName: "",
            type: "",
            data: "",
            view: value.tcCmndNdd && value.tcCmndNdd === 1,
          },
          [FiledNameFromLockCer.TC_DK0101.filed]: {
            fileName: "",
            type: "",
            data: "",
            view: value.tcDk0101 && value.tcDk0101 === 1,
          },
          [FiledNameFromLockCer.CN_XACNHANTOCHUC.filed]: {
            fileName: "",
            type: "",
            data: "",
            view: value.cnXacnhantochuc && value.cnXacnhantochuc === 1,
          },
          [FiledNameFromLockCer.CN_CMND.filed]: {
            fileName: "",
            type: "",
            data: "",
            view: value.cnCmnd && value.cnCmnd === 1,
          },
          [FiledNameFromLockCer.CN_DK0102.filed]: {
            fileName: "",
            type: "",
            data: "",
            view: value.cnDk0102 && value.cnDk0102 === 1,
          },
        };
        const fileAdditionalSerial = {
          type: value.type,
          linkDk02: value.linkDk02,
          certificateSerial: value.certificateSerial,
          files: files,
          object: value.object,
          dateCts: value.dateCts,
          specifiedDate: value.specifiedDate,
        };
        // console.log('fileAdditionalSerial: ', fileAdditionalSerial);

        setSpecifiedDate(value.specifiedDate);
        fileAdditionalNews.push(fileAdditionalSerial);
      });
      // setVisbleFiles(visbleFilesArray);
      // setFileAdditionals(fileAdditionalNews);
      // Chỉ dành cho các trường hợp thiếu hồ sơ -end
    }
    if (data.notificationResponse) {
      if (
        data.notificationResponse.details &&
        data.notificationResponse.details.length > 0
      ) {
        handleLockTokenDetails(
          data.notificationResponse.details,
          fileAdditionalNews
        );
      }else{
        setFileAdditionals(fileAdditionalNews);
      }
      form.setFieldsValue({
        name: data.notificationResponse.name,
        phone: data.notificationResponse.phone,
        email: data.notificationResponse.email,
      });
      setNotificationResponse(data.notificationResponse);
      if (data.notificationResponse.status === SupportStatus.ACCEPT) {
        disableViewTutorial();
      }
      setIsFinish(data.notificationResponse.status === SupportStatus.WAITING);
    }
  };

  const handleLockTokenDetails = (details, fileAdditionalNew) => {
    // Tạo resultMap từ details
    const resultMap = details.reduce((map, detail) => {
      const valueMap = {
        linkDk02: detail.linkDk02,
        files: detail.files,
      };
      map[detail.certificateSerial] = valueMap;
      return map;
    }, {});

    // Duyệt qua từng item trong fileAdditionalNew và cập nhật giá trị
    const updatedFileAdditionalNew = fileAdditionalNew.map((item, index) => {
      const valueMap = resultMap[item.certificateSerial];
      if (!valueMap) {
        // Nếu không tìm thấy certificateSerial trong resultMap, trả về item như cũ
        return item;
      }

      let updatedFiles = { ...item.files };

      valueMap.files.forEach((file) => {
        const type = getFiledByType(file.type);

        // Cập nhật file theo type
        updatedFiles = {
          ...updatedFiles,
          [type]: {
            ...item.files[type],
            id: file.id,
            fileName: file.fileName,
            type: file.type,
            data: file.fileData,
            fileId: file.fileId,
            fileData: file.fileData,
          },
        };

        // Đặt giá trị vào form theo từng type
        if (
          type === FiledNameFromLockCer.TC_GTPL.filed ||
          type === FiledNameFromLockCer.CN_XACNHANTOCHUC.filed
        ) {
          form.setFieldsValue({
            [`${index}dkkd`]: file.fileName,
          });
        }
        if (
          type === FiledNameFromLockCer.CN_CMND.filed ||
          type === FiledNameFromLockCer.TC_CMND_NDD.filed
        ) {
          form.setFieldsValue({
            [`${index}cmnd`]: file.fileName,
          });
        }
        if (
          type === FiledNameFromLockCer.CN_DK0102.filed ||
          type === FiledNameFromLockCer.TC_DK0101.filed
        ) {
          form.setFieldsValue({
            [`${index}dk01`]: file.fileName,
          });
        }
      });

      // Trả về item đã cập nhật
      return {
        ...item,
        files: updatedFiles,
      };
    });

    // Cập nhật state với giá trị mới
    setFileAdditionals(updatedFileAdditionalNew);
  };

  return (
    <Spin
      spinning={loading}
      tip="Vui lòng đợi..."
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      <Helmet>
        <title>{Titles.NOTI_NOT_ENOUGH_DOC.value}</title>
      </Helmet>
      <Row
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}
        className="noti-doc-container no-scroll"
      >
        <Header
          notificationResponse={notificationResponse}
          // visbleFiles={visbleFiles}
          specifiedDate={specifiedDate}
          isFinish={isFinish}
        ></Header>
        {notificationResponse &&
          notificationResponse.status !== SupportStatus.ACCEPT && (
            <Form
              onFinish={onFinish}
              layout="vertical"
              className="noti-doc-form"
              form={form}
            >
              {notificationResponse.status === SupportStatus.REFUSE && (
                <span className="text-is-finish">
                  Lý do Hồ sơ bổ sung bị từ chối:{" "}
                  {notificationResponse.reasonRefusal}
                </span>
              )}

              <ContactInfo
                notificationResponse={notificationResponse}
                isFinish={isFinish}
              />
              {/* Hồ sơ cần bổ sung */}
              <ProfileMissing
                notificationResponse={notificationResponse}
                isFinish={isFinish}
                // visbleFiles={visbleFiles}
                setFileAdditionals={setFileAdditionals}
                fileAdditionals={fileAdditionals}
                setLoading={setLoading}
                form={form}
              />
              {/* Buttons */}
              {isFinish ? (
                <>
                  <Form.Item>
                    <Row justify="center">
                      <Col>
                        <Button
                          icon={<ReloadOutlined />}
                          type="primary"
                          onClick={fetchDataDetail}
                        >
                          Tải lại trang
                        </Button>
                      </Col>
                    </Row>
                  </Form.Item>
                </>
              ) : (
                <Form.Item>
                  <Row justify="center">
                    <Col>
                      <Button
                        icon={<SendOutlined />}
                        type="primary"
                        htmlType="submit"
                      >
                        Gửi thông tin
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              )}
            </Form>
          )}

        {/* <Row className="noti-doc-footer">
          <span className="text-contact">
            Tổng đài: <span className="text-contact-hig">1900.2066</span> -
            Nhánh 1| Email:{" "}
            <span className="text-contact-hig">support@fastca.vn</span> |
            Website:
            <span className="text-contact-hig"> https://fastca.vn/</span>{" "}
          </span>
        </Row> */}
        <Footer></Footer>
      </Row>
      {isOpenModalProm ? (
        <ModalPromotion
          setModalOpen={setIsOpenModalProm}
          isModalOpen={isOpenModalProm}
          link={linkPromotion}
        ></ModalPromotion>
      ) : (
        ""
      )}
    </Spin>
  );
};

export default NotificationDoc;
